interface IConditionalWrapper {
    children?: JSX.Element | JSX.Element[];
    condition: boolean;
    wrapper: (children?: JSX.Element | JSX.Element[]) => JSX.Element;
}

export function ConditionalWrapper({ condition, wrapper, children }: IConditionalWrapper): JSX.Element {
    return condition ? wrapper(children) : <>{children}</>;
}
